import { Component, Input, output } from '@angular/core';
import { LargeFamilyCardItemForm } from '../large-family-card-item.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LargeFamilyCardAppEntityLargeFamilyCardWrite } from '../../../../../../../openapi';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-large-family-card-item-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  templateUrl: './large-family-card-item-form.component.html'
})
export class LargeFamilyCardItemFormComponent {
  @Input()
  public form: LargeFamilyCardItemForm | undefined;

  public cancel = output<void>();

  public submit = output<LargeFamilyCardAppEntityLargeFamilyCardWrite>();

  @Input()
  public edit = false;

  public onSubmit(): void {
    if (this.form?.valid) {
      this.submit.emit(this.form.value);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.cancel.emit();
    this.form?.reset();
  }
}
